import { RequestError } from "../requestError";
import api from "../axiosBase";
import { getURL } from "../serviceHelper";
import { getEnv } from "../../AppConfigs";

const SPSiteId = getEnv("REACT_APP_SP_SITE_ID");
const SPListID = getEnv("REACT_APP_NOTIFY_LIST_ID");
const expand = "&expand=fields(select=Title,N_x1ed9_idung,Created,Status,NotifyTo)";

export class NotifyService {
  static async getNotify(department?: string) {
    try {
      const response = await api.get(getURL(`/sites/${SPSiteId}/lists/${SPListID}/items?${expand}&$top=5000`));
      const result = response.data.value.map((item: any) => NotifyService.mapData(item));
      return {
        data: result,
        count: result.length,
      };
    } catch (error) {
      console.log(error);
      throw new RequestError(error);
    }
  }

  static async getNotifyWithId(id: string) {
    try {
      const response = await api.get(getURL(`/sites/${SPSiteId}/lists/${SPListID}/items/${id}?${expand}`));
      return this.mapData(response?.data);
    } catch (error) {
      throw new RequestError(error);
    }
  }

  static async addNotify(fields: any) {
    try {
      const response = await api.post(getURL(`/sites/${SPSiteId}/lists/${SPListID}/items`), fields);
      return response.data;
    } catch (error) {
      throw new RequestError(error);
    }
  }

  static async updateNoitfy(id: any, fields: any) {
    try {
      const response = await api.patch(getURL(`/sites/${SPSiteId}/lists/${SPListID}/items/${id}/fields`), fields);
      return response.data;
    } catch (error) {
      throw new RequestError(error);
    }
  }

  static mapData(notifyItem: any) {
    return {
      id: notifyItem.id,
      title: notifyItem.fields.Title,
      content: notifyItem.fields.N_x1ed9_idung,
      timeReceived: notifyItem.fields.Created,
      viewed: notifyItem.fields.Status,
      notifyTo: notifyItem.fields.NotifyTo,
    };
  }
}
